import {createSelector} from "reselect";
import {belongsToGroup} from "./util.js";

const getLocation = (state, props) => props.location;

export const getBelongsToScreenGroup = createSelector(
  [getLocation],
  (location) => (screenGroup) => belongsToGroup(location, screenGroup)
);
